import { ArrowRight } from "lucide-react";
import React from "react";

const Info = ({ data }) => {
  return (
    <div className="w-[90%] mx-auto bg-[#F0F2F4] py-12 rounded-[28px] my-16 relative">
      <div className="flex flex-col items-center">
        <h5 className="font-popinsSemiBold text-themeColor text-4xl lg:text-6xl xl:w-[75%] mx-auto text-center lg:tracking-[-5px]">
          {data.title}
        </h5>
        <p className="font-popinsMedium text-base text-textColor w-[90%] lg:w-[70%] mx-auto text-center pt-3">
          {data.desc}
        </p>
        <button className="w-[90%] lg:w-[30%] group relative inline-flex mt-5 items-center justify-between rounded-full bg-[#1D1D1F] pl-10 pr-[6px] py-1 text-sm font-medium lg:gap-8 transition-all duration-300 hover:bg-white hover:text-black hover:border hover:border-[#1D1D1F] shadow text-white hover:shadow-md">
          <span className="font-popinsMedium">{data.btnText}</span>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white group-hover:bg-[#1D1D1F] transition-all duration-300 group-hover:translate-x-1 group-hover:shadow">
            <ArrowRight className="w-4 h-4 text-black group-hover:text-white" />
          </span>
        </button>
      </div>
      <div className="absolute bottom-2 left-0 w-52 h-40 xl:w-72 xl:h-48 hidden lg:block">
        <img src="/assets/features/info.png" alt="" className="object-fill size-full"/>
      </div>
    </div>
  );
};

export default Info;
